import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { userSelector } from "../store/slices/userSlice";
import { ROUTES } from "../constants";

export function PermissionGate({ children }) {
  const userData = useSelector(userSelector);
  const userPermission = userData?.permissions || {};
  const applicationAccessIsNone = userPermission?.application?.edit === false;
  const userAccessIsNone = userPermission?.user?.access === "self";
  const hasApplicationQuoteView = userPermission?.application?.quote_view === true;

  if (applicationAccessIsNone && userData?.isAdmin) {
    return <Navigate to={ROUTES.ADMIN.TENANTS} replace />;
  }

  if (applicationAccessIsNone && userAccessIsNone) {
    return hasApplicationQuoteView ? <Navigate to={ROUTES.APP.QUOTES} replace /> : <Navigate to={ROUTES.APP.CALCULATOR} replace />;
  }

  if (applicationAccessIsNone && !userAccessIsNone) {
    return <Navigate to={ROUTES.APP.USERS} replace />;
  }

  return children;
}
